module.exports = __webpack_public_path__ + "media/logos/logo_conisen-c241748f.png";